import { z } from 'zod';

const lineSchema = z.object({
  serialNo: z.string().trim().min(1, '請填寫產品序號'),
  problemDescription: z.string().trim().min(1, '請填寫問題描述'),
  accessories: z.string().optional().nullable(),
  salesDate: z.string().optional().nullable(),
  warrantyExpiryDate: z.string().optional().nullable(),
  remark: z.string().optional().nullable(),
  version: z.string().optional().nullable(),
  /** 後端唯讀預覽；write 不送。 */
  productCode: z.string().optional().nullable(),
  itemName: z.string().optional().nullable(),
  hasProductPreview: z.boolean().optional(),
});

export const repairRequestFormSchema = z.object({
  repairRequestNo: z.string().trim().min(1, '請填寫報修單號'),
  repairRequestDate: z.string().min(1, '請填寫報修日'),
  remark: z.string().optional().nullable(),
  /** 客戶關聯；write payload 送 customer_id（編輯僅變更時送）。 */
  customerId: z.string().optional().nullable(),
  /** UI 暫存「帶入聯絡人」；write payload 禁止送 contact_id。 */
  contactId: z.string().optional().nullable(),
  customerName: z.string().optional().nullable(),
  contactName: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  fax: z.string().optional().nullable(),
  taxId: z.string().optional().nullable(),
  /** UI 暫存「選擇地址」；write payload 只送 address 字串。 */
  addressId: z.string().optional().nullable(),
  address: z.string().optional().nullable(),
  receivedDate: z.string().optional().nullable(),
  lines: z.array(lineSchema).min(1, '至少一筆明細'),
});

export const REPAIR_REQUEST_FIELD_LABELS = {
  repairRequestNo: '報修單號',
  repairRequestDate: '報修日',
  remark: '備註',
  customerId: '客戶',
  contactId: '帶入聯絡人',
  customerName: '客戶名稱',
  contactName: '聯絡人',
  phone: '電話',
  fax: '傳真',
  taxId: '統編',
  addressId: '選擇地址',
  address: '地址',
  receivedDate: '收件日',
  lines: '明細',
  'lines.serialNo': '產品序號',
  'lines.problemDescription': '問題描述',
  'lines.accessories': '配件（多個請換行）',
  'lines.salesDate': '銷售日',
  'lines.warrantyExpiryDate': '保固迄日',
  'lines.remark': '明細備註',
  'lines.version': '版本',
};
